import axios from 'axios';
import { HTTP_CONFIG } from './config';

const CommonHttp = axios.create();

CommonHttp.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

CommonHttp.interceptors.request.use((config) => {
  const {url} = config;
  if (url.indexOf('register') > 0 || url.indexOf('areas') > 0 || url.indexOf('sysCategory') > 0) {
  // if (url.indexOf('register') > 0 || url.indexOf('areas') > 0) {
    config.url = HTTP_CONFIG.baseUrl + config.url;
  }
  return config;
},(err) => {
  return Promise.reject(err)
})

CommonHttp.interceptors.response.use(function(res){
  //最终还是要兼容一下老接口
  console.log(res);
  const {data} = res;
  if (data.status && data.status === '0') {
    //老接口的成功
    return Promise.resolve(data.data);
  }else if(data.status && data.status !== '0'){
    //老接口的失败
    return Promise.reject(data.msg);
  }
  return Promise.resolve(data);
},function(err){
  let response = err.response;
  //这里根据出错类型分别处理
  //4开头的为登录问题，return code
  if(response){
     if (response.status === 401 || response.status === 403 || response.status === 405) {
    return Promise.reject(response.status);
  } else if(response.status === 404){
    return Promise.reject(404);
  }else if (response.data) {
    return Promise.reject(`${response.data}`)
  }else{
    return Promise.reject('出错了');
  }
  }
 
})

export default CommonHttp;